import Api from "../api";

export default async function apiDeleteMcu(id: string) {
  return await Api.delete<string>({
    input: `/api/v1/mcu/${id}`,
  });
}
